/**
 * usePrefetchOnHover — handlers React para precargar stream WHEP en hover.
 *
 * Sprint Performance Live — Día 4.
 *
 * Uso:
 *   const hoverHandlers = usePrefetchOnHover({ siteId, channel, token })
 *   <div {...hoverHandlers} onClick={...}>...</div>
 *
 * Debounce 200ms — si el operador pasa el mouse rápido sobre varios items,
 * no dispara prefetch en cada uno, solo en los que se quedan ≥200ms (los
 * que el operador "considera"). Reduce conexiones WHEP fake al sidecar M4.
 */

import { useRef } from 'react'
import { prefetchStream } from '../lib/prefetchStream'

export function usePrefetchOnHover({ siteId, channel, token, delay = 200, enabled = true }) {
  const timerRef = useRef(null)

  if (!enabled || siteId == null || channel == null || !token) {
    return { onMouseEnter: () => {}, onMouseLeave: () => {} }
  }

  const onMouseEnter = () => {
    if (timerRef.current) return   // ya hay timer corriendo
    timerRef.current = setTimeout(() => {
      prefetchStream({ siteId, channel, token })
      timerRef.current = null
    }, delay)
  }

  const onMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }

  return { onMouseEnter, onMouseLeave }
}
